// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1OigM","noInteraction":"EventWrapper_noInteraction__LEj8Z","pointerPassthrough":"EventWrapper_pointerPassthrough__2fhjW"};